module.exports = __webpack_public_path__ + "images/444c856afb2a1888059fb418c18791ff-showcase-button.png";